export default __webpack_public_path__ + "static/media/Service_pic4.343fed1b.png";